function getArrivedFromExternalSite(referrer, hostName) {
    return !referrer || (referrer.indexOf(hostName) < 0 && referrer.indexOf('homeaway') < 0);
}

export {getArrivedFromExternalSite};
